import { Key } from 'react'
import { Button } from '@/components/ui/button'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { formatNome } from '@/utils/format'
import useAllUsers from '../hooks/use-all-users'
import { useNavigate } from 'react-router-dom'
import { useCurrentUser } from '@/features/auth/state/auth'

interface User {
  id?: string
  cpf?: string
  name?: string
  email?: string
  typeUser?: string
  typeCargo?: string
  id_tenant?: string
  nome?: string
  cnpjcpf?: string
  typeCategoria?: string
  status?: string
}

export default function ListarUsuariosAll() {
  const navigate = useNavigate()
  const user = useCurrentUser()
  const { loadingUsers, userError, filteredUsers } = useAllUsers()

  if (loadingUsers) return <p>Carregando...</p>
  if (userError) return <p>{userError?.message}</p>

  const handleNavigate = (user: User) => {
    // setSelectedUser(user)
    // setShowEditDialog(true)
    if (!user?.id) return
    navigate(`/admin/usuarios/${user.id}/permissoes`)
  }

  return (
    <>
      {((user?.permissions.permission_product && user?.typeCargo === 'ANALISTA') || user?.typeCargo === 'CEO') && (
        <div>
          {filteredUsers.length > 0 ? (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-[200px] md:w-[250px]">Nome</TableHead>
                  <TableHead className="hidden md:table-cell">Email</TableHead>
                  <TableHead className="hidden lg:table-cell">Cargo</TableHead>
                  <TableHead className="hidden md:table-cell">CNPJ</TableHead>
                  <TableHead>Tipo</TableHead>
                  <TableHead>Ações</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredUsers.map((user: User, index: Key | null | undefined) => (
                  <TableRow key={index}>
                    <TableCell className="font-medium">{formatNome(user.name || '')}</TableCell>
                    <TableCell className="hidden md:table-cell">{user.email}</TableCell>
                    <TableCell className="hidden text-center lg:table-cell">
                      {formatNome(user.typeCargo || '')}
                    </TableCell>
                    <TableCell className="hidden text-center md:table-cell">{user.id_tenant}</TableCell>
                    <TableCell className="text-center">
                      {user.typeUser === 'ADMIN' ? 'Administrador' : 'Usuário'}
                    </TableCell>
                    <TableCell>
                      <Button size="sm" onClick={() => handleNavigate(user)}>
                        Ver Detalhes
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div className="text-center text-gray-500 py-10">
              Nenhum usuário encontrado com os critérios selecionados.
            </div>
          )}
        </div>
      )}
    </>
  )
}
